<template>
  <div>
    <b-row>
      <b-col lg="2">
        <h5>{{ $t('question') }}</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(image, imageIndex) in question.images" :key="imageIndex" lg="1" style="padding: 0px; margin-left: 15px; margin-bottom: 15px; min-width: 150px;">
          <b-card>
            <b-row>
              <b-col>
                <b-img :src="image.imageUrl" fluid alt="" center />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
    </b-row>
    <h5>{{ $t('questionalternative') }}</h5>
      <b-list-group>
    <b-row>
        <b-col v-for="(alternative, alternativeIndex) in question.alternatives"
                :key="alternativeIndex">
          <b-card>
          <b-row>
            <b-col style="margin-top:10px;">
              <b-img :src="alternative.imageUrl" fluid alt="" center />
            </b-col>
          </b-row>
        </b-card>
        </b-col>
    </b-row>
      </b-list-group>
  </div>
</template>

<script>

export default {
  name: 'display-module-gfig',
  props: {
    question: {}
  }
}
</script>
